import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Icons from '../../Elements/Icons/index.js';
import { Step } from './Step.js';
import { StepsGroupWrapper } from './styled.js';
// Create a function to create steps.
// It hides the generic type implementation from the user.
export function createSteps(steps) {
    return steps;
}
export const StepsGroup = ({ steps, onClick, dataTestId }) => (_jsx(StepsGroupWrapper, { "data-testid": dataTestId ?? 'steps-group', children: steps.map((step, idx) => {
        const { id, title, type } = step;
        const StepComponent = Step[type];
        const isLast = idx === steps.length - 1;
        return (_jsxs(React.Fragment, { children: [_jsx(StepComponent, { id: id, stepNumber: idx + 1, title: title, onClick: () => onClick(step) }), !isLast && _jsx(Icons.Chevron, { align: 'right' })] }, id));
    }) }));
